import { ModalDialogContainer } from '@common/modal'
import {
  Alert,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@common/material'
import ClearIcon from '@mui/icons-material/Clear'
import React from 'react'
import { useModal } from '@common/GlobalModal'
import { localizedStrings } from '@core/strings'
import { RegisterItemPropertyFormItemProps } from '@modules/registers/items/form'
import { useToast } from '@core/toast'
import { useRemoveRegisterItemFormulaOverride } from '@core/react-query/features/registers/registers/register/items/item/hooks/useRemoveRegisterItemFormulaOverride'

export const RegisterItemRemoveFormulaOverrideModal: React.FC<
  RegisterItemPropertyFormItemProps
> = (props) => {
  const { hideModal } = useModal()
  const toast = useToast()

  const removeRegisterItemFormulaOverride =
    useRemoveRegisterItemFormulaOverride()

  return (
    <ModalDialogContainer>
      <DialogTitle
        variant='h5'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        sx={{ pr: 1, fontSize: 20 }}
      >
        {localizedStrings.overrideFormulaValue}
        <IconButton aria-label='close-modal' onClick={hideModal}>
          <ClearIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Alert sx={{ mb: 2 }} severity={'warning'}>
          {localizedStrings.removeRegisterItemFormulaOverrideWarning}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={hideModal}>
          {localizedStrings.cancel}
        </Button>
        <Button
          variant='contained'
          onClick={() => {
            removeRegisterItemFormulaOverride.mutate(
              {
                registerId: props.register.id,
                registerItemId: props.registerItem.id,
                registerPropertyId: props.property.id,
              },
              {
                onSuccess: () => {
                  toast.success(localizedStrings.updated)
                  hideModal()
                },
                onError: (e) => {
                  toast.error(e.message)
                },
              },
            )
          }}
        >
          {localizedStrings.remove}
        </Button>
      </DialogActions>
    </ModalDialogContainer>
  )
}
